import { HttpContextToken } from '@angular/common/http'

/**
 * We need to skip the standard error checking by
 * bypassing this and throwing the exception up the chain.
 *
 * Usage:
 *  http.get(url, { context: new HttpContext().set(ERROR_INTERCEPTOR_BYPASS, [403]) })
 */
export const ERROR_INTERCEPTOR_BYPASS = new HttpContextToken(() => [-1])
export const HANDLE_ERROR_AND_THROW = new HttpContextToken(() => false)
export const IGNORE_ERROR = new HttpContextToken(() => [-1])

/**
 * We need this to trigger the commands drawer loading
 * so the experience is a little smoother.
 *
 * Usage:
 *  http.get(url, { context: new HttpContext().set(HELIOS_COMMAND_HTTP_TOKEN, true) })
 */
export const HELIOS_COMMAND_HTTP_TOKEN = new HttpContextToken(() => false)
